declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
    __gtmLoaded?: boolean;
    __gtmRetryCount?: number;
  }
}

/** Load GTM exactly once (no duplicates), safe for Safari 17.x */
export function loadGTM(containerId: string, dataLayerName = 'dataLayer'): void {
  if (!containerId || window.__gtmLoaded) return;

  // const base = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(containerId)}&l=${encodeURIComponent(dataLayerName)}`;
  const base = '/metrics/';
  // If using ngsw, you will need to bypass cache for GTM
  // const base = `https://www.googletagmanager.com/gtm.js?ngsw-bypass=true&id=${encodeURIComponent(containerId)}&l=${encodeURIComponent(dataLayerName)}`;
  const scriptId = 'GTMscript';
  let s = document.getElementById(scriptId) as HTMLScriptElement | null;

  (window as any)[dataLayerName] = (window as any)[dataLayerName] || [];
  (window as any)[dataLayerName].push({ 'gtm.start': Date.now(), event: 'gtm.js' });

  if (!s) {
    s = document.createElement('script');
    s.async = true;
    s.id = scriptId;
    s.crossOrigin = 'anonymous';       // better error surfaces
    (s as any).fetchPriority = 'high'; // hint to browser
    document.head.prepend(s);
  }

  const tryLoad = () => {
    const n = (window.__gtmRetryCount ?? 0);
    // const bust = `rt=${n}&ts=${Date.now()}`; // not needed with Tag Gateway
    s!.src = base;
    // (optional) console marker so you can see attempts:
    console.log('[GTM] load attempt', n + 1, s!.src);
  };

  s.onerror = () => {
    const n = (window.__gtmRetryCount ?? 0) + 1;
    window.__gtmRetryCount = n;
    if (n > 3) {
      console.warn('[GTM] loader failed after retries');
      window.dataLayer?.push({ event: 'gtm_loader_failed', attempts: n });
      return;
    }
    const delay = Math.pow(3, n - 1) * 1000; // 1s, 3s, 9s
    setTimeout(tryLoad, delay);
  };

  s.onload = () => {
    window.__gtmLoaded = true;
    console.log('[GTM] loaded');
  };

  tryLoad();
}